import { useEffect, useState } from "react";
import { Box, IconButton, useTheme } from "@mui/material";

function ScrollTopButton2() {
  const [scrollPercent, setScrollPercent] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      const percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

      setScrollPercent(percent);
      setVisible(scrollTop > 300);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 50,
        width: 60,
        height: 60,
        borderRadius: "50%",
        border: "4px solid #8B4A2B",
        background: "#f5f1ee",
        boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
        backdropFilter: "blur(20px)",
        overflow: "hidden",
        transition: "all 0.5s",
        transform: visible ? "translateY(0)" : "translateY(20px)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      {/* Liquid Fill */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: `${scrollPercent}%`,
          background: "linear-gradient(180deg, #a4542d 0%, #8B4A2B 100%)",
          transition: "height 0s ease-out",
        }}
      />

      {/* Inner White Stroke */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          borderRadius: "50%",
          border: "3px solid #fff",
          zIndex: 10,
          pointerEvents: "none",
        }}
      />

      {/* Apple Style Chevron */}
      <IconButton
        onClick={scrollToTop}
        aria-label="Scroll to top"
        sx={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 20,
          borderRadius: "50%",
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
        disableRipple
      >
        <Box
          component="svg"
          width="22px"
          height="14px"
          viewBox="0 0 22 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          sx={{ position: "relative", zIndex: 10, fontSize: "10px" }}
        >
          <Box
            component="path"
            d="M2 11L11 2L20 11"
            stroke={scrollPercent > 45 ? "#ffffff" : "#8B4A2B"}
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
            sx={{ transition: "stroke 0.3s ease-out" }}
          />
        </Box>
      </IconButton>
    </Box>
  );
}

export default ScrollTopButton2;
